import { h, FunctionComponent } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { useDispatch } from 'react-redux';
import { trackFormBlur } from '~src/utils/tracking';
import { InputProps } from '../types/forms';

/**
  Usage: A secure <input> with css class, label
*/
const SecureInput: FunctionComponent<InputProps> = props => {
  const {
    id,
    value,
    onChangeHandler,
    type = '',
    isDisabled = false,
    isRequired = false,
    isReadOnly = false,
    className = '',
    autoFocus = false,
    placeholder = '',
    maxLength = 100,
  } = props;
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  const onBlurHandler = () => {
    dispatch(trackFormBlur(id));
    setIsFocused(false);
  };

  const onFocusHandler = () => {
    setIsFocused(true);
  };

  return (
    <div
      ref={inputRef}
      id={id}
      tabIndex={0}
      type={type || 'text'}
      value={value}
      className={`${className} ${isFocused ? 'focused' : ''}`}
      disabled={isDisabled}
      aria-disabled={isDisabled}
      aria-required={isRequired}
      aria-live='off'
      readOnly={isReadOnly}
      placeholder={placeholder}
      maxLength={maxLength}
      autoFocus={autoFocus}
      onChange={onChangeHandler}
      onBlurCapture={onBlurHandler}
      onFocusCapture={onFocusHandler}
    />
  );
};

export default SecureInput;
